<template lang="pug">
div
	.duvidas_frequentes__question_row(@click = "toggle" v-bind:class="{ 'expand' : isShown }" :id="normalize(question)" 'v-if'='answer')
		.duvidas_frequentes__question('v-html'="question") xx
		.duvidas_frequentes__answer('v-html'="answer") xx

	a(:href="download", download).duvidas_frequentes__question_row.duvidas_frequentes__question_row--download(:id="normalize(question)" 'v-if'='download' )
		.duvidas_frequentes__question('v-html'="question") xx
		p download 
	a(:href="download_2", download).duvidas_frequentes__question_row.duvidas_frequentes__question_row--download(:id="normalize(question)" 'v-if'='download_2' )
		p
		p download 
	a(:href="view").duvidas_frequentes__question_row.duvidas_frequentes__question_row--visualizar(:id="normalize(question)" 'v-if'='view')
		.duvidas_frequentes__question('v-html'="question") xx
		p visualizar
	a.duvidas_frequentes__question_row(:id="normalize(question)" 'v-if'='files')
		.duvidas_frequentes__question('v-html'="question") xx
		.duvidas_frequentes__answer('v-html'="answer" v-if="answer")

		ul.duvidas_frequentes__question_row--files
			li(v-for="(value, name) in files" :key="name")
				a(:href="value" ) {{name}}
	hr.duvidas_frequentes__divisor
</template>

<script>
export default {
	props: [ "question", "answer", "download", "view", "files", "download_2" ],
	data: function() {
		return {
			isShown: false,
			BASE_URL: process.env.BASE_URL
		}
	},
	methods: {
		toggle: function() {
			this.isShown = !this.isShown;
		},
		normalize: function(text) {
			return text.toLowerCase().replace(/ /gi, '-').replace(/&/gi, '').replace(/\(/gi, '').replace(/\)/gi, '').normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\?/gi, '');
		},
	}
}
</script>

<style lang="css">

.install-a1{
	margin-top: 20px;
}
.install-a1 img {
	width: 100%;
}

.duvidas_frequentes__question_row.expand .duvidas_frequentes__answer{
	max-height: 800px !important;
}


</style>